import { Tag, ShieldCheck, Boxes } from "lucide-react";
import Reveal from "./Reveal";

const REASONS = [
  {
    icon: Tag,
    title: "Private Label & OEM",
    desc: "Custom branding, packaging, and labeling tailored to your market requirements.",
  },
  {
    icon: ShieldCheck,
    title: "Quality Assurance",
    desc: "Pre-shipment inspection on every order — documented and transparent.",
  },
  {
    icon: Boxes,
    title: "Flexible MOQs",
    desc: "From sample orders to full container loads — we scale with your business.",
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why" className="section-shell relative overflow-hidden">
      <div className="gradient-mesh pointer-events-none">
        <div className="gradient-blob w-[450px] h-[450px] bg-accent/25 -right-20 top-10 animate-blob-drift" />
        <div className="gradient-blob w-[380px] h-[380px] bg-accent-2/20 -left-24 bottom-0 animate-blob-drift-2" />
      </div>

      <div className="section-inner relative z-10">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-primary tracking-tight">
            Why Trade With Us
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {REASONS.map((item, i) => {
            const Icon = item.icon;
            return (
              <Reveal key={item.title} delay={i * 100}>
                <div className="h-full bg-surface/90 backdrop-blur-sm border border-border rounded-2xl p-8 hover:border-accent/50 transition-colors">
                  <div className="w-12 h-12 rounded-xl bg-accent/15 flex items-center justify-center mb-5">
                    <Icon size={22} className="text-accent" />
                  </div>
                  <h3 className="font-serif text-xl font-bold text-primary">{item.title}</h3>
                  <p className="mt-3 text-sm text-muted leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
